export default function Avatar({ user, size = 'sm' }) {
  const sizes = {
    sm: 'w-8 h-8 text-sm',
    md: 'w-10 h-10 text-base',
    lg: 'w-16 h-16 text-2xl',
  };

  if (user?.picture) {
    return (
      <img
        src={user.picture}
        alt={user.name}
        referrerPolicy="no-referrer"
        className={`${sizes[size].split(' ').slice(0, 2).join(' ')} rounded-full object-cover`}
      />
    );
  }

  return (
    <div className={`${sizes[size]} rounded-full bg-blue-100 flex items-center justify-center`}>
      <span className="font-semibold text-blue-600">{user?.name?.charAt(0).toUpperCase()}</span>
    </div>
  );
}
